unit UBarcodeScannerForm;

interface

uses
  System.SysUtils, System.Classes, JS, Web, WEBLib.Graphics, WEBLib.Controls,
  WEBLib.Forms, WEBLib.Dialogs, Vcl.StdCtrls, WEBLib.StdCtrls, UMainConfig,
  Vcl.Imaging.pngimage, Vcl.Controls, WEBLib.ExtCtrls, WEBLib.Devices,
  UWebBarcodeScanner, UMatModel, UMatList;

type
  TBarcodeScannerForm = class(TForm)
    pnlHeader: TPanel;
    imgLogo: TImageControl;
    lblHeader: TLabel;
    btnBack: TImageControl;
    pnlFooter: TPanel;
    WebCam: TCamera;
    procedure btnBackClick(Sender: TObject);
    procedure WebFormResize(Sender: TObject);
    procedure WebFormCreate(Sender: TObject);
    procedure WebFormClose(Sender: TObject; var Action: TCloseAction);
    procedure WebFormOrientationChange(Sender: TObject;
      AOrientation: TScreenOrientation);
  private
    FMainConfig: TMainConfig;
    FBarcodeScanner: TBarcodeScanner;
    FMat: TMatModel;
    FMatList: TMatList;
    procedure HandleError(Sender: TObject; AMsg: string);
    procedure HandleDetect(Sender: TObject; ACode: string);
    procedure SetMainConfig(const Value: TMainConfig);
    procedure SetBarcodeScanner(const Value: TBarcodeScanner);
    procedure SetMat(const Value: TMatModel);
    procedure SetMatList(const Value: TMatList);
  public
    property MainConfig: TMainConfig read FMainConfig write SetMainConfig;
    property BarcodeScanner: TBarcodeScanner read FBarcodeScanner
      write SetBarcodeScanner;
    property Mat: TMatModel read FMat write SetMat;
    property MatList: TMatList read FMatList write SetMatList;
  protected procedure LoadDFMValues; override; end;

var
  BarcodeScannerForm: TBarcodeScannerForm;

implementation

uses
  UEssentialHelper, WEBLib.Storage;

{$R *.dfm}

procedure TBarcodeScannerForm.btnBackClick(Sender: TObject);
begin
  Self.MainConfig.TimerReset;
  Self.Close;
end;

procedure TBarcodeScannerForm.HandleDetect(Sender: TObject; ACode: string);
  procedure HandleSuccess(Sender: TObject);
  begin
    if Sender is TMatModel then
    begin
      Self.Mat := Sender as TMatModel;
      Self.MatList.Add(Self.Mat);
    end;
    Self.Close;
  end;
  procedure ErrorHandling(Sender: TObject; AMsg: string);
  begin
    Self.Mat := Self.MatList.GetByCode(ACode);
    if Self.Mat = nil then
      MessageDLG(AMsg, mtError, [mbOK], nil);
    Self.Close;
  end;

begin
  Self.MainConfig.TimerReset;
  Self.BarcodeScanner.Stop;
  Self.Mat := TMatModel.Create;
  Self.Mat.OnSuccess := HandleSuccess;
  Self.Mat.OnError := ErrorHandling;
  Self.Mat.GetByCode(Self.MainConfig.Uri, ACode);
end;

procedure TBarcodeScannerForm.HandleError(Sender: TObject; AMsg: string);
begin
  MessageDLG(AMsg, mtError, [mbOK], nil);
end;

procedure TBarcodeScannerForm.SetBarcodeScanner(const Value
  : TBarcodeScanner);
begin
  FBarcodeScanner := Value;
end;

procedure TBarcodeScannerForm.SetMainConfig(const Value: TMainConfig);
begin
  FMainConfig := Value;
  Self.MainConfig.CurrentForm := Self.Name;
  ColorComponents(Self, Self.MainConfig.ColorConfig);
  pnlFooter.Caption := Self.MainConfig.Copyright;
  Self.WebFormResize(Self);
  Self.BarcodeScanner.AcceptedBarcodeTypes :=
    Self.MainConfig.BarcodeScannerConfig.BarcodeTypes;
  Self.BarcodeScanner.BeepOnDetect := Self.MainConfig.BarcodeScannerConfig.ScannerBeep;
  Self.BarcodeScanner.Start;
end;

procedure TBarcodeScannerForm.SetMat(const Value: TMatModel);
begin
  FMat := Value;
end;

procedure TBarcodeScannerForm.SetMatList(const Value: TMatList);
begin
  FMatList := Value;
end;

procedure TBarcodeScannerForm.WebFormClose(Sender: TObject;
  var Action: TCloseAction);
begin
  Self.BarcodeScanner.Stop;
end;

procedure TBarcodeScannerForm.WebFormCreate(Sender: TObject);
begin
  Self.BarcodeScanner := TBarcodeScanner.Create(WebCam);
  Self.BarcodeScanner.OnDetect := Self.HandleDetect;
  Self.BarcodeScanner.OnError := Self.HandleError;
  Self.MatList := TMatList.Create(true);
end;

procedure TBarcodeScannerForm.WebFormOrientationChange(Sender: TObject;
  AOrientation: TScreenOrientation);
begin
  Self.WebFormResize(Sender);
end;

procedure TBarcodeScannerForm.WebFormResize(Sender: TObject);
var
  i: Integer;
begin
  if (Self.Height < 480) or (Self.Width < 640) then
  begin
    btnBack.Width := 24;
    btnBack.Height := 24;
    btnBack.Top := 4;
    btnBack.Left := 4;
    lblHeader.Font.Size := 10;
    lblHeader.Top := 7;
    imgLogo.Width := 74;
    imgLogo.Height := 24;
    imgLogo.Top := 4;
    pnlHeader.Height := 32;
    pnlFooter.Visible := false;
    lblHeader.Caption := 'Barcode-Scanner';
    i := (Self.ClientHeight - pnlHeader.Height - WebCam.Height) div 2;
    if i < 0 then
      i := 0;
    WebCam.Top := pnlHeader.Top + pnlHeader.Height + i;
  end
  else
  begin
    btnBack.Width := 48;
    btnBack.Height := 48;
    btnBack.Top := 8;
    btnBack.Left := 8;
    lblHeader.Font.Size := 16;
    lblHeader.Top := 16;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.Top := 8;
    pnlHeader.Height := 64;
    pnlFooter.Visible := true;
    lblHeader.Caption := 'Winzeit - WebPortal - Barcode-Scanner';
    i := (Self.ClientHeight - pnlHeader.Height - pnlFooter.Height -
      WebCam.Height) div 2;
    if i < 0 then
      i := 0;
    WebCam.Top := pnlHeader.Top + pnlHeader.Height + i;
  end;
  pnlHeader.Width := Self.ClientWidth;
  pnlFooter.Width := pnlHeader.Width;
  lblHeader.Left := btnBack.Left + btnBack.Width + 8;
  lblHeader.Width := pnlHeader.ClientWidth - imgLogo.Width - 32;
  imgLogo.Left := pnlHeader.ClientWidth - imgLogo.Width - 16;
  i := (Self.ClientWidth - WebCam.Width) div 2;
  if i < 0 then
    i := 0;
  WebCam.Left := i;
end;

procedure TBarcodeScannerForm.LoadDFMValues;
begin
  inherited LoadDFMValues;

  pnlHeader := TPanel.Create(Self);
  imgLogo := TImageControl.Create(Self);
  lblHeader := TLabel.Create(Self);
  btnBack := TImageControl.Create(Self);
  pnlFooter := TPanel.Create(Self);
  WebCam := TCamera.Create(Self);

  pnlHeader.BeforeLoadDFMValues;
  imgLogo.BeforeLoadDFMValues;
  lblHeader.BeforeLoadDFMValues;
  btnBack.BeforeLoadDFMValues;
  pnlFooter.BeforeLoadDFMValues;
  WebCam.BeforeLoadDFMValues;
  try
    Name := 'BarcodeScannerForm';
    Width := 640;
    Height := 480;
    SetEvent(Self, 'OnClose', 'WebFormClose');
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    SetEvent(Self, 'OnOrientationChange', 'WebFormOrientationChange');
    SetEvent(Self, 'OnResize', 'WebFormResize');
    pnlHeader.SetParentComponent(Self);
    pnlHeader.Name := 'pnlHeader';
    pnlHeader.Left := 0;
    pnlHeader.Top := 0;
    pnlHeader.Width := 640;
    pnlHeader.Height := 64;
    pnlHeader.Align := alTop;
    pnlHeader.Caption := 'pnlHeader';
    pnlHeader.ChildOrder := 4;
    pnlHeader.Color := clSkyBlue;
    pnlHeader.ShowCaption := False;
    imgLogo.SetParentComponent(pnlHeader);
    imgLogo.Name := 'imgLogo';
    imgLogo.Left := 480;
    imgLogo.Top := 8;
    imgLogo.Width := 148;
    imgLogo.Height := 48;
    imgLogo.HeightPercent := 100.000000000000000000;
    imgLogo.WidthPercent := 100.000000000000000000;
    imgLogo.Picture.LoadFromFile('UBarcodeScannerForm.pnlHeader.imgLogo.Picture.png');
    lblHeader.SetParentComponent(pnlHeader);
    lblHeader.Name := 'lblHeader';
    lblHeader.Left := 64;
    lblHeader.Top := 16;
    lblHeader.Width := 410;
    lblHeader.Height := 30;
    lblHeader.Alignment := taCenter;
    lblHeader.AutoSize := False;
    lblHeader.Caption := 'Winzeit - WebPortal - Barcode-Scanner';
    lblHeader.Font.Charset := DEFAULT_CHARSET;
    lblHeader.Font.Color := clWindowText;
    lblHeader.Font.Height := -21;
    lblHeader.Font.Name := 'Segoe UI';
    lblHeader.Font.Style := [fsBold];
    lblHeader.HeightPercent := 100.000000000000000000;
    lblHeader.ParentFont := False;
    lblHeader.WidthPercent := 100.000000000000000000;
    btnBack.SetParentComponent(pnlHeader);
    btnBack.Name := 'btnBack';
    btnBack.Left := 16;
    btnBack.Top := 16;
    btnBack.Width := 32;
    btnBack.Height := 32;
    btnBack.HeightPercent := 100.000000000000000000;
    btnBack.WidthPercent := 100.000000000000000000;
    btnBack.ChildOrder := 2;
    SetEvent(btnBack, Self, 'OnClick', 'btnBackClick');
    btnBack.Picture.LoadFromFile('UBarcodeScannerForm.pnlHeader.btnBack.Picture.png');
    pnlFooter.SetParentComponent(Self);
    pnlFooter.Name := 'pnlFooter';
    pnlFooter.Left := 0;
    pnlFooter.Top := 456;
    pnlFooter.Width := 640;
    pnlFooter.Height := 24;
    pnlFooter.Align := alBottom;
    pnlFooter.Alignment := taLeftJustify;
    pnlFooter.Caption := 'pnlFooter';
    pnlFooter.ChildOrder := 1;
    pnlFooter.Color := clSkyBlue;
    WebCam.SetParentComponent(Self);
    WebCam.Name := 'WebCam';
    WebCam.Left := 120;
    WebCam.Top := 104;
    WebCam.Width := 400;
    WebCam.Height := 300;
    WebCam.CameraType := ctRear;
  finally
    pnlHeader.AfterLoadDFMValues;
    imgLogo.AfterLoadDFMValues;
    lblHeader.AfterLoadDFMValues;
    btnBack.AfterLoadDFMValues;
    pnlFooter.AfterLoadDFMValues;
    WebCam.AfterLoadDFMValues;
  end;
end;

end.
